import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useLazyPropertyCreateQuery,
  useLazyPropertyServiceViewQuery,
  useLazyServicesCreateQuery,
  usePropertyServiceAddMutation,
  usePropertyServiceEditMutation,
} from "../../redux/api/api";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { saveLoader } from "../../redux/slice/loaderNoti";

const JustWalk = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.itemType;
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [propertyServiceAddApi] = usePropertyServiceAddMutation();
  const [propertyServiceEditApi] = usePropertyServiceEditMutation();
  const [propertyServiceViewApi] = useLazyPropertyServiceViewQuery();
  const [propertyServiceCreateApi] = useLazyServicesCreateQuery();
  const [propertyCreateApi] = useLazyPropertyCreateQuery();

  const [createList, setCreateList] = useState({});
  const [dayOutingData, setDayOutingData] = useState({});
  const [amenities, setamenities] = useState([]);
  const [admin_commision, setadmin_commision] = useState("");
  const [adult_price, setadult_price] = useState("");
  const [child_price, setchild_price] = useState("");
  const [min_persons, setmin_persons] = useState("");
  const [max_persons, setmax_persons] = useState("");
  const [min_childrens, setmin_childrens] = useState("");
  const [max_childrens, setmax_childrens] = useState("");
  const [percentage, setpercentage] = useState("");
  const [weekend, setWeekend] = useState(false);
  const [weekendErr, setWeekendErr] = useState(false);
  const [amenitiesErr, setamenitiesErr] = useState(false);
  const [admin_commisionErr, setadmin_commisionErr] = useState(false);
  const [adult_priceErr, setadult_priceErr] = useState(false);
  const [child_priceErr, setchild_priceErr] = useState(false);
  const [min_personsErr, setmin_personsErr] = useState(false);
  const [min_childrensErr, setmin_childrensErr] = useState(false);
  const [max_childrensErr, setmax_childrensErr] = useState(false);
  const [max_personsErr, setmax_personsErr] = useState(false);
  const [percentageErr, setpercentageErr] = useState(false);

  const [monday, setMonday] = useState(false);
  const [tuesday, setTuesday] = useState(false);
  const [wednesday, setWednesday] = useState(false);
  const [thursday, setThursday] = useState(false);
  const [friday, setFriday] = useState(false);
  const [saturday, setSaturday] = useState(false);
  const [sunday, setSunday] = useState(false);

  const getPropertyCreate = () => {
    propertyCreateApi()
      .unwrap()
      .then((res) => {
        setCreateList(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getPropertyServiceCreate = () => {
    propertyServiceCreateApi()
      .unwrap()
      .then((res) => {
        setCreateList(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.itemType == "edit") {
      getPropertyServiceCreate();
    } else {
      getPropertyCreate();
    }
  }, []);

  const getView = () => {
    dispatch(saveLoader(true));
    propertyServiceViewApi({
      type: "just_walking",
      id: location?.state?.item?.id,
    })
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          let data = res?.just_walking;
          let day_outing = data?.weekend_days;
          setDayOutingData(data);

          if (data?.weekend_percentage) {
            setWeekend(true);

            if (day_outing?.includes("monday")) {
              setMonday(true);
            }
            if (day_outing?.includes("tuesday")) {
              setTuesday(true);
            }
            if (day_outing?.includes("wednesday")) {
              setWednesday(true);
            }
            if (day_outing?.includes("thursday")) {
              setThursday(true);
            }
            if (day_outing?.includes("friday")) {
              setFriday(true);
            }
            if (day_outing?.includes("saturday")) {
              setSaturday(true);
            }
            if (day_outing?.includes("sunday")) {
              setSunday(true);
            }

            setpercentage(data?.weekend_percentage);
          }

          setadmin_commision(data?.serviceprice?.admin_commission);
          let amenities_ = [];

          res?.amenities?.map((item, ind) => {
            amenities_.push(item?.id);
          });

          setamenities(amenities_);
          setadult_price(data?.serviceprice?.adult_price);
          setchild_price(data?.serviceprice?.child_price);
          setmax_childrens(data?.serviceprice?.max_childrens);
          setmin_childrens(data?.serviceprice?.min_childrens);
          setmin_persons(data?.serviceprice?.min_persons);
          setmax_persons(data?.serviceprice?.max_persons);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.item?.id) {
      getView();
    }
  }, []);

  const handleChange = (selectedItems) => {
    let flavors = [];
    for (let i = 0; i < selectedItems.length; i++) {
      flavors.push(selectedItems[i].value);
    }
    setamenities(flavors);
  };

  const submitHandler = () => {
    let weekendCheck;

    if (weekend) {
      if (
        monday != true &&
        tuesday != true &&
        wednesday != true &&
        thursday != true &&
        friday != true &&
        saturday != true &&
        sunday != true
      ) {
        weekendCheck = true;
      }
    }

    if (
      admin_commision?.length == 0 ||
      adult_price?.length == 0 ||
      // child_price?.length == 0 ||
      // min_childrens?.length == 0 ||
      // max_childrens?.length == 0 ||
      max_persons?.length == 0 ||
      // min_persons?.length == 0 ||
      weekendCheck == true ||
      (weekend == true && percentage?.length == 0) ||
      amenities?.length == 0
    ) {
      setadmin_commisionErr(true);
      setadult_priceErr(true);
      // setchild_priceErr(true);
      // setmax_childrensErr(true);
      setmax_personsErr(true);
      // setmin_childrensErr(true);
      // setmin_personsErr(true);
      setamenitiesErr(true);
      setWeekendErr(true);
      if (weekend && percentage?.length == 0) {
        setpercentageErr(true);
      }
    } else {
      const formdata = new FormData();
      formdata.append("amenities", amenities.toString());
      formdata.append("admin_commision", admin_commision);
      formdata.append("adult_price", adult_price);
      formdata.append("child_price", 0);
      formdata.append("min_persons", 0);
      formdata.append("max_persons", max_persons);
      formdata.append("min_childrens", 0);
      formdata.append("max_childrens", 0);
      formdata.append("type", "just_walking");
      formdata.append("amenity_type", "1");

      if (weekend) {
        formdata.append("weekend_percentage", percentage);

        let weekend_days = "";

        if (monday == true) {
          weekend_days += ",monday";
        }
        if (tuesday == true) {
          weekend_days += ",tuesday";
        }
        if (wednesday == true) {
          weekend_days += ",wednesday";
        }
        if (thursday == true) {
          weekend_days += ",thursday";
        }
        if (friday == true) {
          weekend_days += ",friday";
        }
        if (saturday == true) {
          weekend_days += ",saturday";
        }
        if (sunday == true) {
          weekend_days += ",sunday";
        }

        formdata.append("weekend_days", weekend_days?.slice(1));
      } else {
        formdata.append("weekend_percentage", "");
        formdata.append("weekend_days", "");
      }

      let count = 1;

      if (count == 1) {
        if (types == "edit") {
          formdata.append("service_price_id", dayOutingData?.serviceprice?.id);
          dispatch(saveLoader(true));
          setBtn(true);
          propertyServiceEditApi({
            id: dayOutingData?.id,
            payload: formdata,
          })
            .unwrap()
            .then((res) => {
              dispatch(saveLoader(false));
              setBtn(false);
              if (res?.status == "success") {
                Swal.fire({
                  text: res?.message,
                  icon: "success",
                });
                navigate(-1);
              }
            })
            .catch((err) => {
              dispatch(saveLoader(false));
              setBtn(false);
              console.log("err", err);
            });
        } else {
          dispatch(saveLoader(true));
          setBtn(true);
          propertyServiceAddApi({
            id: location?.state?.data?.id,
            payload: formdata,
          })
            .unwrap()
            .then((res) => {
              dispatch(saveLoader(false));
              setBtn(false);
              if (res?.status === "success") {
                Swal.fire({
                  text: res?.message,
                  icon: "success",
                });
                navigate(-1);
              }
            })
            .catch((err) => {
              dispatch(saveLoader(false));
              setBtn(false);
              console.error("Error", err);
            });
        }
      }
    }
  };

  const handleWeekend = () => {
    setMonday(false);
    setThursday(false);
    setTuesday(false);
    setWednesday(false);
    setFriday(false);
    setSaturday(false);
    setSunday(false);
    setWeekendErr(false);
    setpercentageErr(false);
    if (weekend) {
      setWeekend(false);
    } else {
      setWeekend(true);
    }
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={types == "edit" ? "edit-just-walking" : "add-just-walking"}
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <div className="col-md-12 mb-3">
            <div className="head-dest">Service Pricing</div>
          </div>
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Admin Commision
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setadmin_commision(e.target.value)}
                  value={admin_commision}
                  type={"number"}
                />
              </div>
              {admin_commision?.length == 0 && admin_commisionErr && (
                <p className="err">Enter Admin Commision</p>
              )}
            </div>
            {admin_commision && (
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Amenities
                  </label>
                  <select
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => handleChange(e.target.selectedOptions)}
                    value={amenities}
                    multiple={true}
                    size={4}
                  >
                    {createList?.amenities?.map((item, ind) => {
                      return (
                        <option value={item?.id} key={ind}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {amenities?.length == 0 && amenitiesErr && (
                  <p className="err">Select Amenities</p>
                )}
              </div>
            )}
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Adult Price
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setadult_price(e.target.value)}
                  value={adult_price}
                  type={"number"}
                />
              </div>
              {adult_price?.length == 0 && adult_priceErr && (
                <p className="err">Enter Adult Price</p>
              )}
            </div>
            {/* <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Child Price
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setchild_price(e.target.value)}
                  value={child_price}
                  type={"number"}
                />
              </div>
              {child_price?.length == 0 && child_priceErr && (
                <p className="err">Enter Child Price</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Minimum Persons
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmin_persons(e.target.value)}
                  value={min_persons}
                  type={"number"}
                />
              </div>
              {min_persons?.length == 0 && min_personsErr && (
                <p className="err">Enter Minimum Persons</p>
              )}
            </div> */}
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Maximum Persons
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmax_persons(e.target.value)}
                  value={max_persons}
                  type={"number"}
                />
              </div>
              {max_persons?.length == 0 && max_personsErr && (
                <p className="err">Enter Maximum Persons</p>
              )}
            </div>
            {/* <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Minimum Childrens
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmin_childrens(e.target.value)}
                  value={min_childrens}
                  type={"number"}
                />
              </div>
              {min_childrens?.length == 0 && min_childrensErr && (
                <p className="err">Enter Minimum Childrens</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Maximum Childrens
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setmax_childrens(e.target.value)}
                  value={max_childrens}
                  type={"number"}
                />
              </div>
              {max_childrens?.length == 0 && max_childrensErr && (
                <p className="err">Enter Maximum Childrens</p>
              )}
            </div> */}
          </Row>
          <div className="col-md-12">
            <div className="booking-range">
              <div className="title">Weekend Price Change</div>
              <div className="range-book">
                <label className="switch">
                  <input
                    type="checkbox"
                    onClick={() => handleWeekend()}
                    checked={weekend}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          {weekend && (
            <div>
              <div className="col-md-12 mt-3">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Select the Weekend Days
                </label>
              </div>
              <div>
                <div className="col-md-12 weekly-price" v-if="weekend">
                  <ul>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-10"
                            className="checkbox-custom"
                            name="checkbox-10"
                            type="checkbox"
                            onClick={() => setMonday(!monday)}
                            checked={monday}
                          />
                          <label
                            for="checkbox-10"
                            className="checkbox-custom-label"
                          >
                            Monday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-11"
                            className="checkbox-custom"
                            name="checkbox-11"
                            type="checkbox"
                            onClick={() => setTuesday(!tuesday)}
                            checked={tuesday}
                          />
                          <label
                            for="checkbox-11"
                            className="checkbox-custom-label"
                          >
                            Tuesday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-12"
                            className="checkbox-custom"
                            name="checkbox-12"
                            type="checkbox"
                            onClick={() => setWednesday(!wednesday)}
                            checked={wednesday}
                          />
                          <label
                            for="checkbox-12"
                            className="checkbox-custom-label"
                          >
                            Wednesday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-13"
                            className="checkbox-custom"
                            name="checkbox-13"
                            type="checkbox"
                            onClick={() => setThursday(!thursday)}
                            checked={thursday}
                          />
                          <label
                            for="checkbox-13"
                            className="checkbox-custom-label"
                          >
                            Thursday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-14"
                            className="checkbox-custom"
                            name="checkbox-14"
                            type="checkbox"
                            onClick={() => setFriday(!friday)}
                            checked={friday}
                          />
                          <label
                            for="checkbox-14"
                            className="checkbox-custom-label"
                          >
                            Friday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-15"
                            className="checkbox-custom"
                            name="checkbox-15"
                            type="checkbox"
                            onClick={() => setSaturday(!saturday)}
                            checked={saturday}
                          />
                          <label
                            for="checkbox-15"
                            className="checkbox-custom-label"
                          >
                            Saturday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-16"
                            className="checkbox-custom"
                            name="checkbox-16"
                            type="checkbox"
                            onClick={() => setSunday(!sunday)}
                            checked={sunday}
                          />
                          <label
                            for="checkbox-16"
                            className="checkbox-custom-label"
                          >
                            Sunday
                          </label>
                        </div>
                      </div>
                    </li>
                  </ul>
                  {weekend &&
                    weekendErr &&
                    monday != true &&
                    tuesday != true &&
                    wednesday != true &&
                    thursday != true &&
                    friday != true &&
                    saturday != true &&
                    sunday != true && <p className="err">Select Weekday</p>}
                </div>

                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Enter the Percentage
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      onChange={(e) => setpercentage(e.target.value)}
                      value={percentage}
                      type={"number"}
                    />
                  </div>
                  {percentage?.length == 0 && percentageErr && (
                    <p className="err">Enter Maximum Childrens</p>
                  )}
                </div>
              </div>
            </div>
          )}
          <Row>
            <div className="col-md-12 text-start mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default JustWalk;
